import AppCoursesIndex from "./course.vue";
import AppCoursesList from "./list/list.vue";
import AppCoursesItem from "./item/item.vue";
import AppCoursesShow from "./item/show.vue";
import AppCoursesOverview from "./list/overview.vue";

const routes = [
  {
    path: "course",
    component: AppCoursesIndex,
    meta: {
      auth: {
        roles: "course.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "course.index",
        component: AppCoursesList,
        meta: {
          auth: {
            roles: "course.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "overview",
        name: "course.overview",
        component: AppCoursesOverview
      },
      {
        path: "create",
        name: "course.create",
        component: AppCoursesItem,
        meta: {
          auth: {
            roles: "course.create",
            redirect: { name: "course.index" }
          }
        }
      },
      {
        path: ":id/show",
        name: "course.show",
        component: AppCoursesShow,
        meta: {
          auth: {
            roles: "course.view",
            redirect: { name: "course.index" }
          }
        }
      },
      {
        path: ":id",
        name: "course.edit",
        component: AppCoursesItem,
        meta: {
          auth: {
            roles: "course.update",
            redirect: { name: "course.index" }
          }
        }
      }
    ]
  }
];

export default routes;
